import React from 'react';
import ReactDOM from 'react-dom/client';
import SaveData from './utils/SaveData';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <SaveData />
  // </React.StrictMode>
);
